
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { BetAreaViewMixin } from './bet-area-mixin'

@Options({})
export default class PcBetArea extends Mixins(BetAreaViewMixin) {}
